import { CourseRegistrationSubheaderCombinedProps } from './types';

const usePresenter = (props: CourseRegistrationSubheaderCombinedProps): CourseRegistrationSubheaderCombinedProps => {
  return props;
};

export default usePresenter;
